import get from '@pkg/utils/objects/get';
import { SortOrder } from '@/lib/enums';

/**
 * @param {String} property
 * @return {Function}
 */
export default function date(property, sortOrder = SortOrder.DESC) {
  return (a, b) => {
    const sourceDate = new Date(
      get(sortOrder === SortOrder.ASC ? a : b, property)
    );
    const targetDate = new Date(
      get(sortOrder === SortOrder.ASC ? b : a, property)
    );

    return sourceDate - targetDate;
  };
}
